var render = function render(){var _vm=this,_c=_vm._self._c;return _c('as-register-comp',{attrs:{"staff-id":_vm.staffId,"account":_vm.account}})
}
var staticRenderFns = []

export { render, staticRenderFns }